import { AlimentoModel } from "./alimento.model";
import { AlimentoPreparadoModel } from "./alimento_preparado.model";
import { SuplementoModel } from "./suplemento.model";

export class PlatilloModel {
    documentContainerId?: string;
    documentId?: string;

    activo: boolean;
    nombre: string;
    descripcion: string;
    imagen?: {
        nombre: string;
        url: string;
    };
    categoria: string;
    detalle: AlimentoModel[] | SuplementoModel[] | AlimentoPreparadoModel[];

    calorias: number;
    carbohidratos: number;
    proteinas: number;
    grasas: number;
    propietario: string;
    empresaId: string;
    guiaId?: string; //Solo si pertenece a una guia
}

export const categoriasPlatillos: string[] = [
    'Desayuno',
    'Comida',
    'Cena',
    'Snack 1',
    'Snack 2'
];
